import { gql } from '@apollo/client';

export default gql`
  mutation UserEnableTwoFactor($code: String!) {
    userEnableTwoFactor(input: { code: $code }) {
      success
    }
  }
`;
